export function logout(navigate) {
  localStorage.clear();
  navigate('/admin-login');
}